import { HorizontalList, theme } from 'aimo-ui';
import MenuItem from 'components/common/MenuItem';
import React from 'react';
import { StyledWrapper } from 'styles/ContainerStyles';
import { isWeb } from 'utils/deviceUtils';
import { testIdentifiers } from 'utils/testIdentifiers';

const LabeledHorizontalCardsList = ({
  listData,
  label,
  smallLabel = '',
  smallLabelColor,
  labelOnPress,
  testIdentifiersPrefix,
  cardComponent,
  cardComponentOptions,
  bold = true,
  benefits,
}: {
  listData: any[];
  label?: string;
  smallLabel?: string;
  smallLabelColor?: string;
  labelOnPress?: () => void;
  testIdentifiersPrefix: string;
  cardComponent: (item: any, options?: any, benefits?: any[]) => JSX.Element;
  cardComponentOptions?: any;
  bold?: boolean;
  benefits?: any[];
}) => {
  if (!listData?.length) {
    return <></>;
  }
  return (
    <StyledWrapper center={isWeb} maxWidth={isWeb ? 600 : undefined}>
      <>
        {label && (
          <MenuItem
            {...testIdentifiers(
              `${testIdentifiersPrefix}-horizontal-section-title`
            )}
            menuLabel={label}
            smallLabel={smallLabel}
            smallLabelColor={smallLabelColor}
            onPress={labelOnPress}
            color={theme.colors.black}
            borderColor={theme.colors.gray100}
            noBorder
            withArrow={!!labelOnPress}
            arrowSize="s"
            bold={bold}
          />
        )}

        <HorizontalList
          listData={listData}
          listElement={({ item }) =>
            cardComponent(item, cardComponentOptions, benefits)
          }
          withBackground={theme.colors.white}
          {...testIdentifiers(`${testIdentifiersPrefix}-horizontal-list`)}
        />
      </>
    </StyledWrapper>
  );
};

export default LabeledHorizontalCardsList;
